/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Pit1_TInputs */

const en_viewer_pit1_t = /** @type {(inputs: Viewer_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Very large documents are limited by browser memory`)
};

const ko_viewer_pit1_t = /** @type {(inputs: Viewer_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아주 큰 문서는 브라우저 메모리에 제약을 받습니다`)
};

const ja_viewer_pit1_t = /** @type {(inputs: Viewer_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非常に大きな文書はブラウザのメモリに制約されます`)
};

/**
* | output |
* | --- |
* | "Very large documents are limited by browser memory" |
*
* @param {Viewer_Pit1_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_pit1_t = /** @type {((inputs?: Viewer_Pit1_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Pit1_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_pit1_t(inputs)
	if (locale === "ko") return ko_viewer_pit1_t(inputs)
	return ja_viewer_pit1_t(inputs)
});